// extracted by mini-css-extract-plugin
export default {"tabContainer":"NavigationTabs_tabContainer__Wk0Dv","navLink":"NavigationTabs_navLink__vncBw"};